import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loginUser, getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(() => {
    try { return JSON.parse(localStorage.getItem('etlb_user')); } catch { return null; }
  });
  const [aircraft, setAircraft] = useState(() => {
    try { return JSON.parse(localStorage.getItem('etlb_aircraft')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, aircraftId, personalId) => {
    setLoading(true);
    try {
      const res = await loginUser(email, aircraftId, personalId);
      const { token, user: u, aircraft: ac } = res.data;
      localStorage.setItem('etlb_token', token);
      localStorage.setItem('etlb_user', JSON.stringify(u));
      localStorage.setItem('etlb_aircraft', JSON.stringify(ac));
      setUser(u);
      setAircraft(ac);
      return { success: true };
    } catch (err) {
      const msg = err.response?.data?.message || 'Login failed';
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('etlb_token');
    localStorage.removeItem('etlb_user');
    localStorage.removeItem('etlb_aircraft');
    setUser(null);
    setAircraft(null);
  }, []);

  const switchAircraft = useCallback((ac) => {
    setAircraft(ac);
    localStorage.setItem('etlb_aircraft', JSON.stringify(ac));
  }, []);

  // Validate token on mount
  useEffect(() => {
    const token = localStorage.getItem('etlb_token');
    if (token && !user) {
      getMe().then(res => {
        setUser(res.data.user);
        localStorage.setItem('etlb_user', JSON.stringify(res.data.user));
      }).catch(() => {
        logout();
      });
    }
  }, [user, logout]);

  return (
    <AuthContext.Provider value={{ user, aircraft, loading, login, logout, switchAircraft }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
